import { Node as ProseMirrorNode, DOMOutputSpec } from 'prosemirror-model'
import { EditorState, Plugin, PluginKey, Transaction } from 'prosemirror-state'

export const placeholderPluginKey = new PluginKey('placeholder')

export const placeholderNodeSpec = {
  inline: true,
  group: 'inline',
  atom: true,
  attrs: {
    id: { default: null },
  },
  parseDOM: [
    {
      tag: 'span.placeholder-node',
      getAttrs: (dom: HTMLElement) => ({
        id: dom.getAttribute('data-id'),
      }),
    },
  ],
  toDOM: (node: ProseMirrorNode): DOMOutputSpec => {
    return [
      'span',
      {
        class: 'placeholder-node',
        'data-id': node.attrs['id'],
      },
      '[●]',
    ] as DOMOutputSpec
  },
}

export function insertPlaceholder(state: EditorState, dispatch: (tr: Transaction) => void): boolean {
  const { schema, tr } = state
  const placeholderType = schema.nodes['placeholder']
  const placeholderNode = placeholderType.create({
    id: Date.now().toString(),
  })
  const transaction = tr.replaceSelectionWith(placeholderNode)
  dispatch(transaction)
  return true
}

export function createPlaceholderPlugin(): Plugin {
  return new Plugin({
    key: placeholderPluginKey,
    props: {
      decorations: () => null,
    },
  })
}
